// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1WisM","signatureButtonsRight":"ModalSign_signatureButtonsRight__1M8IA"};